import styles from './Button.module.css';

const Button = ({ label, onClick, variant = 'primary', disabled = false, type = 'button' }) => {
  return (
    <button
      type={type}
      className={`${styles.button} ${styles[variant]}`}
      onClick={onClick}
      disabled={disabled}
      aria-disabled={disabled}
    >
      {label}
    </button>
  );
};

export default Button;
